import parse from 'html-react-parser';
import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import ConnUrls from '../Connections/ConnectURL';
import { MobiOrNotContext } from "../Contexts/MobiOrNot_Context";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import styles from './HomePTopSlides.module.css';
import MobiStyles from './HomePTopSlidesMobi.module.css';

import 'swiper/css';  // Core styles
import 'swiper/css/navigation';  // Navigation module styles
import 'swiper/css/pagination';  // Pagination module styles


const HomePTopSlides = (props) => {
  // const [currentPage, setCurrentPage] = useContext(CurrentPContext);
  const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
  const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : MobiStyles);

  const [timgs, setTimgs] = useState(props.topImages);

  useEffect(() => {
    setCurrentStyle(!mobiOrNot ? styles : MobiStyles)
  }, [mobiOrNot]);

  


  // const getslds = () => {

  return (
    <div className={currnetStyle.HPTopImages}>
      <Swiper
        modules={[Pagination, Autoplay]}
        className={currnetStyle.HPTopSwiper}
        spaceBetween={0}
        slidesPerView={1}
        pagination={!mobiOrNot ? true : false}
        speed={1000}
        loop={true}
        autoplay={{ delay: 4000 }}

        // onSlideChange={() => console.log('slide change')}
        freeMode={false}
      // onSwiper={(swiper) => console.log(swiper)}
      >
        {
          timgs.map((item, index) => {

            return (
              <SwiperSlide key={index}
                className={`${currnetStyle.HPTopImagesItm}`}>
                <div className={currnetStyle.HPTImgWrap}
                  style={{
                    backgroundImage:
                      `url("${ConnUrls.servMediasUrl}${!mobiOrNot || item.imgMobi === "" ? item.img : item.imgMobi}")`
                  }}
                >

                </div>

                <div className={`${currnetStyle.HPTopimgInBlock}`}>

                  {
                    ((item.headTxt && item.headTxt !== "") ||
                      (item.txt && item.txt !== "" && item.txt !== "<p><br></p>")) &&
                    <div className={`${currnetStyle.HPTopimgInBlockTxt} regularPoint`}>
                      {
                        item.headTxt && item.headTxt !== "" &&
                        <div className={`${currnetStyle.txtHead}`}>
                          {parse(`${item.headTxt}`)}
                        </div>
                      }
                      {
                        item.txt && item.txt !== "" && item.txt !== "<p><br></p>" &&
                        <div className={`${currnetStyle.theTxt}`}>
                          {parse(`${item.txt}`)}
                        </div>
                      }

                    </div>
                  }
                  {item.txt && item.lnk && item.lnk != "" &&
                    <div className={`${currnetStyle.HPTopimgInBlockBtn} pointing`}>

                      <a href={item.lnk} className={`${currnetStyle.thBtnitm} `}>
                        {item.btnTxtLink}
                      </a>
                    </div>

                  }
                </div>



                {/* </div> */}
              </SwiperSlide>

            )

          })
        }

      </Swiper>

    </div >
  )


  // }

  // return (getslds())
}

export default HomePTopSlides;



